import { cloudChiprApi } from "@/services/cloudchipr.api";
import { infrastructureArchitectureRecommendationFixedCacheKey } from "@/store/infrastructure-architecture/utils/constants/constants";
import { RootState } from "@/store/store";
import { infrastructureArchitectureSelectedResourceIdSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitectureSelectedResourceIdSelector";

const endpoint =
  cloudChiprApi.endpoints.postUsersMeSolutionArchitectsRecommendations.select;

export const getInfrastructureArchitectureRecommendationEndpointSelector = (
  state: RootState,
) => {
  const resourceId =
    infrastructureArchitectureSelectedResourceIdSelector(state);

  return endpoint(
    `${infrastructureArchitectureRecommendationFixedCacheKey}${resourceId ?? ""}`,
  )(state);
};
